import { defineMessages, useIntl } from 'react-intl';
import {
  isEnglishLearningArabic,
  ARABIC_SCRIPT_REPLIT_URL,
} from 'src/utils/replit/shouldRedirectToArabicScriptReplit';
import { openReplitInNewTab } from 'src/utils/replit/openReplitInNewTab';
import { getLanguagePairId } from 'src/utils/language/getLanguagePairId';
import { Button, Icon, SvgHelperWrapper } from 'src/components';
import DotsImage from '../../Buddies/dots.svg';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'arabic_script_home_card_title', defaultMessage: 'Arabic Script' },
  description: {
    id: 'arabic_script_home_card_description',
    defaultMessage: 'Everything you need to learn the Arabic script.',
  },
  cta: { id: 'arabic_script_home_card_cta', defaultMessage: 'Learn Now' },
});

export const ArabicScriptHomeCard = () => {
  const intl = useIntl();

  if (!isEnglishLearningArabic()) return null;

  const handleClick = () => {
    const languagePairId = getLanguagePairId();
    void openReplitInNewTab({
      replitUrl: ARABIC_SCRIPT_REPLIT_URL,
      languagePairId,
    });
  };

  return (
    <S.Card data-testid="arabic-script-home-card">
      <SvgHelperWrapper Svg={DotsImage} />
      <S.Content>
        <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
        <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
        <Button buttonType="secondary" onClick={handleClick}>
          {intl.formatMessage(msgs.cta)}
        </Button>
      </S.Content>
      <S.IconDecoration>
        <Icon name="arabicScript" />
      </S.IconDecoration>
    </S.Card>
  );
};

export default ArabicScriptHomeCard;
